import React from 'react'
import { Link } from 'react-router-dom'
import './FooterCopyRight.css'

function FooterCopyRight() {
    return (
        <div className='FooterCopyRight'>
            <span className="copyRightTxt">© <Link href="/">Splooge</Link>, Inc. All rights reserved.</span>
        </div>
    )
}

export default FooterCopyRight
